var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"footer-props":_vm.footerProps,"no-data-text":_vm.noDataText,"items":_vm.gridItems,"server-items-length":_vm.itemsLength,"headers":_vm.headers}})
}
var staticRenderFns = []

export { render, staticRenderFns }